import gql from 'graphql-tag';

export const FooterQuery = gql`
    query {
        footer {
            emailWidget {
                buttonLabel
                endpointUrl
                failure
                info
                inputLabel
                invalidEmail
                success
            }
            family {
                title
                sites {
                    link
                    name
                    text
                }
            }
            legal {
                copyright
                termsAndConditions
            }
            logo {
                altText
                image
                link
                text
            }
            partnerLogo {
                altText
                image
                link
                text
                partnershipText
            }
            sitePartnerLogo {
                image
            }
            siteInfo {
                companyLinks {
                    link
                    text
                }
                companyTitle
                title
                userLinks {
                    link
                    text
                }
            }
            smsWidget {
                countryCode
                countryCodes
                endpointUrl
                i18n
                title
            }
            social {
                link
                text
            }
        }
    }
`;
